import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { needsClientProfileOnboarding } from '@core/portal/clientPortal.util';
import { useAuth } from '@/contexts/AuthContext';
import { usePortalPath } from '@/hooks/usePortalPath';

type ClientOnboardingGateProps = {
  children: React.ReactNode;
};

const ClientOnboardingGate = ({ children }: ClientOnboardingGateProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { path: portalPath } = usePortalPath();
  const onboardingPath = portalPath('/onboarding');

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const isOnboardingRoute = location.pathname === onboardingPath;

  if (user && needsClientProfileOnboarding(user)) {
    if (!isOnboardingRoute) {
      return <Navigate to={onboardingPath} replace />;
    }

    return <>{children}</>;
  }

  if (isOnboardingRoute) {
    return <Navigate to={portalPath('/jobs')} replace />;
  }

  return <>{children}</>;
};

export default ClientOnboardingGate;
